import React from "react";
import styles from "./index.module.scss";
const StepNumber = ({ label, backgroundColor, }) => {
    return (React.createElement("div", { className: styles.stepNumber, style: { backgroundColor } }, label));
};
export default StepNumber;
